module.exports = __webpack_public_path__ + "img/person_6.518833ba.jpg";